import { render } from "./currency-selector.vue?vue&type=template&id=4f3867f8&ts=true"
import script from "./currency-selector.vue?vue&type=script&lang=ts"
export * from "./currency-selector.vue?vue&type=script&lang=ts"

import "./currency-selector.vue?vue&type=style&index=0&id=4f3867f8&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__